import { render } from "./contact_element.vue?vue&type=template&id=db2c7484&scoped=true"
import script from "./contact_element.vue?vue&type=script&lang=js"
export * from "./contact_element.vue?vue&type=script&lang=js"

import "./contact_element.vue?vue&type=style&index=0&id=db2c7484&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db2c7484"]])

export default __exports__